import ContentMarkdown from "../ContentMarkdown";
import { PolicyTextStyle } from "../PolicyTextStyle";
import Loader from "../Loader";
import { useActiveLang } from "../../domains/app/hooks/useActiveLang";
import { useMarkdown } from "../../domains/app/hooks/useMarkdown";
import { LEGAL_DOCS } from "../settings/sheet/views/LegalView";

// Every privacy markdown opens with its own title ("## PRIVACY POLICY"); the
// surfaces that show this text already title it.
const LEADING_TITLE = /^#{1,6} [^\n]*\n+/;

/**
 * The privacy policy of Juisci alone, without the Partners tab of the legal
 * view: the objection screen (Figma O1.signup-objection.privacy) and "Partner
 * sharing" (O4.settings.privacy) show the partners in their own list.
 */
export function JuisciPrivacyPolicy(): React.JSX.Element {
  const { activeLang } = useActiveLang();
  const localized = LEGAL_DOCS.privacy[activeLang];
  const { content } = useMarkdown(
    localized === undefined ? LEGAL_DOCS.privacy.en : localized
  );

  if (content === null)
    return (
      <div className="flex justify-center py-10">
        <Loader />
      </div>
    );
  return (
    <PolicyTextStyle>
      <ContentMarkdown math={false} linkVariant="anchor">
        {content.replace(LEADING_TITLE, "")}
      </ContentMarkdown>
    </PolicyTextStyle>
  );
}
